var _path, _path2, _mask, _rect, _rect2, _mask2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSkip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04187 7.78955C4.04187 5.51586 4.79977 5.51586 6.31556 5.51586L15.7896 5.51586L15.7896 4.00007L6.31556 4.00007C3.28398 4.00007 2.52608 5.51586 2.52608 7.78955L2.52608 11.2001H4.04187L4.04187 7.78955Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3053 5.51578C19.579 5.51578 19.579 6.27368 19.579 7.78947H17.3053L20.3369 10.821L23.3685 7.78947H21.0948C21.0948 4.75789 19.579 3.99999 17.3053 3.99999H15.7896V5.51578H17.3053Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2530_147153",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 12.842,
    width: 6.31579,
    height: 6.31579,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.842,
    width: 6.31579,
    height: 6.31579,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_2530_147153)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8418,
    y: 12.842,
    width: 6.31579,
    height: 6.31579,
    rx: 1,
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_2530_147153",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.6841,
    y: 12.842,
    width: 6.31579,
    height: 6.31579,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6841,
    y: 12.842,
    width: 6.31579,
    height: 6.31579,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-5-inside-2_2530_147153)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkip);
export default __webpack_public_path__ + "static/media/icon_skip.331cf8acc639599f76645a348577f18f.svg";
export { ForwardRef as ReactComponent };